// @flow
import React, { Component } from 'react';
import { Modal, Button } from 'semantic-grab-ui/src';
import { City } from 'types/country';

import GeofencePicker from './GeofencePicker';

type Props = {
  show: boolean,
  cities: Array<City>,
  onChange: Function,
  title: String,
};

export default class GeofenceAddModal extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      modalOpen: props.show,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.setState({ modalOpen: nextProps.show });
  }

  handleClose = () => {
    this.setState({ modalOpen: false });
    this.props.onChange();
  }

  handleConfirm = () => {
    this.setState({ modalOpen: false });
    this.props.onChange(this.selectedGeoFence);
  }

  handleChange = ({ code, version }: Object) => {
    this.selectedGeoFence = { code, version };
    this.forceUpdate();
  }

  render() {
    const { modalOpen } = this.state;
    return (
      <Modal
        open={modalOpen}
        onClose={this.handleClose}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{this.props.title}</Modal.Header>
        <Modal.Content>
          <GeofencePicker onChange={this.handleChange} cities={this.props.cities} />
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={this.handleClose}>Cancel</Button>
          <Button
            disabled={this.selectedGeoFence === undefined}
            color="green"
            onClick={this.handleConfirm}
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
